import { Component, OnInit } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard-cctv-notstreaming',
  templateUrl: './dashboard-cctv-notstreaming.component.html',
  styleUrls: ['./dashboard-cctv-notstreaming.component.scss']
})
export class DashboardCctvNotstreamingComponent implements OnInit {
  selected_value: any;
  cctvnotstreaming: any []=[];
  show: boolean = true;
  filterBy: any;
  id: any;
  searchkey: string = '';
  public searchTerm: string = '';
  hide: boolean = false;
  constructor(public campuscctvserviceservice: CampuscctvserviceService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.notstreamingdata()
  }
  notstreamingdata() {
    this.spinner.show();
    this.selected_value = "STATE"
    this.campuscctvserviceservice.getcctvnotstreaming(this.selected_value).subscribe((res) => {
      if (res == null) {
        this.cctvnotstreaming = [];
      }else{
        this.cctvnotstreaming = res;
      }
      this.spinner.hide();
    })
    this.searchTerm = '';
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    });
    this.search({ event: { target: { value: '' } } })
  }
  onOptionsSelected(e: any) {
    this.show = true
    this.spinner.show();
    this.selected_value = e.target.value
    if (this.selected_value === 'STATE' || this.selected_value === 'CITY' || this.selected_value === 'CAMPUS') {
      this.campuscctvserviceservice.getcctvnotstreaming(this.selected_value).subscribe((res) => {
        if (res == null) {
          this.cctvnotstreaming = [];
        } else {
          this.cctvnotstreaming = res;
          this.hide = false;
        }
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    }
  }

  navigatertochange(data: any) {
    console.log(data);
    this.filterBy = data.filterBy
    this.id = data.id;
    this.hide = true;
    this.spinner.show();
    if (this.filterBy == "STATE") {
      localStorage.setItem('stateId', data.id);
      this.campuscctvserviceservice.getnotstreamingright(this.filterBy, this.id).subscribe((res) => {
        console.log(res);
        this.cctvnotstreaming = res;
        this.spinner.hide();
      })
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    } else if (this.filterBy == "CITY") {
      localStorage.setItem('cityId', data.id);
      this.campuscctvserviceservice.getnotstreamingright(this.filterBy, this.id).subscribe((res) => {
        console.log(res);
        this.cctvnotstreaming = res;
        this.spinner.hide();
      })
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    }
    else if (this.filterBy == "CAMPUS") {
      localStorage.setItem('campusId', data.id);
      this.show = false;
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    }
  }


  navigateBackward(data: any) {
    const filterBy = data.filterBy
    const id = data.id;
    this.spinner.show();
    if (filterBy == 'CAMPUS' && this.show == false) {
      this.campuscctvserviceservice.getnotstreamingright("CITY", localStorage.getItem('cityId')).subscribe((res) => {
        this.cctvnotstreaming = res;
        this.show = true;

        console.log(res);
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
      if (this.selected_value === "CAMPUS") {
        this.hide = false;
      }

    } else if (filterBy == 'CAMPUS' && this.show == true) {
      if (localStorage.getItem('stateId')) {
        this.campuscctvserviceservice.getnotstreamingright("STATE", localStorage.getItem('stateId')).subscribe((res) => {
          this.cctvnotstreaming = res;
          console.log(res);
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      else {
        this.campuscctvserviceservice.getcctvnotstreaming(this.selected_value).subscribe((res) => {
          // localStorage.setItem('stateId', res.id);
          this.cctvnotstreaming = res;
          console.log(this.cctvnotstreaming);
          this.spinner.hide();
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      if (this.selected_value === "CITY") {
        this.hide = false;
      }
    }
    else if (filterBy == "CITY") {
      this.hide = false;
      this.notstreamingdata();
    }

  }

  search(event: any) {
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
  }
}
